import { useQuery } from "react-query";
import axios from "axios";
import { MARKET } from "./marketplaceRoutes";

export const DEFAULT_SHIPPING_FEES = {
  pickupFee: 250,
  doorFee: 620,
  pickupLabel: "Pickup station",
  doorLabel: "Door delivery",
  sectionTitle: "Shipping & returns",
  deliveryFeeLabel: "Delivery Fees",
  detailsButtonLabel: "Details",
  pickupEstimate: "Estimated 3–5 business days after checkout",
  pickupDetailsText:
    "Select pickup at checkout. You will be notified when your order arrives.",
  doorEstimate: "Estimated 3–5 business days after checkout",
  doorDetailsText:
    "Estimated 3–5 business days. Delivery attempted up to 2 times.",
  overlayTitle: "Delivery Details",
  overlayFeeLabel: "Total Delivery Amount",
  returnPolicyTitle: "Return Policy",
  returnPolicyText: "Free return within 14 days for ALL eligible items",
  returnPolicyLink: MARKET.RETURN_POLICY,
  payOnDeliveryEnabled: true,
  payOnDeliveryMaxAmount: 200000,
  payOnDeliveryBlockDays: 60,
  payOnDeliveryAllowGuest: false,
};

export const mergeShippingSettings = (settings) => ({
  ...DEFAULT_SHIPPING_FEES,
  ...settings,
});

export const fetchMarketplaceShippingFees = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/marketplace-shipping/fees`
  );
  return mergeShippingSettings(response.data.settings);
};

const useMarketplaceShippingFees = () => {
  return useQuery(
    ["marketplaceShippingFees"],
    fetchMarketplaceShippingFees,
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
    }
  );
};

export const getShippingCostFromSettings = (settings, method) => {
  const merged = mergeShippingSettings(settings);
  return method === "pickup" ? merged.pickupFee : merged.doorFee;
};

export default useMarketplaceShippingFees;
